module.exports = __webpack_public_path__ + "img/mc_symbol.534760f2.svg";